import React from "react";
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: "primary" | "dark";
  pulse?: boolean;
  className?: string;
}
export function CtaButton({
  children,
  href = "#planes",
  variant = "primary",
  pulse = false,
  className = ""
}: CtaButtonProps) {
  const base = "inline-flex items-center justify-center gap-2 font-condensed tracking-wide text-xl sm:text-2xl px-8 py-4 rounded-xl uppercase transition-transform duration-200 hover:scale-[1.03] active:scale-95 w-full text-center leading-tight";
  const styles = variant === "primary" ? "bg-[#e10600] text-white hover:bg-[#c40500] shadow-lg shadow-red-900/40" : "bg-black text-white border-2 border-[#e10600] hover:bg-[#1a1a1a]";
  const external = href.startsWith("http");
  return <a href={href} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} className={`${base} ${styles} ${pulse ? "animate-pulse-cta" : ""} ${className}`} data-id="element-22" data-mp="19ajt38kw6bzb">
      {children}
    </a>;
}